import { CriteriaNumberRange } from '../../../../../../../../types/cmsProduct';
import { extractGiftRange } from '../../../../../../../../utils/helpers';
import { tr } from '../../../../../../../../utils/translations/tr';
import { formatAmount } from '../../../../formatAmount';
import { OffersPlText } from '../../../../i18n';
import { LoanBand } from './types';

// Rows are the union of the stored bands; two bands share a row only when
// Prefix, Min, Max and Suffix all match, never by their rendered label.
export const getLoanBands = (
  loanRanges: CriteriaNumberRange[],
  currency: string,
  text: OffersPlText,
): LoanBand[] => {
  const bands = new Map<string, LoanBand>();
  loanRanges.forEach((range) => {
    const key = [range.prefix, range.value_start, range.value_end, range.suffix]
      .map((field) => field ?? '')
      .join('|');
    if (bands.has(key)) return;

    const { start, end } = extractGiftRange([range], 'ELIGIBLE_LOAN_RANGE');
    const prefix = range.prefix || currency;
    const from = formatAmount(start ?? 0, prefix, range.suffix);
    bands.set(key, {
      key,
      start: start ?? 0,
      end,
      label:
        end === null
          ? tr('amount_and_above', text, { amount: from })
          : `${from} - ${formatAmount(end, prefix, range.suffix)}`,
    });
  });

  return [...bands.values()].sort(
    (a, b) => b.start - a.start || (b.end ?? Infinity) - (a.end ?? Infinity),
  );
};
